// extracted by mini-css-extract-plugin
export default {"container":"Produtos_container__U2s7t"};